import { buildApiUrl } from "@/config.js";
import { useState, useEffect } from "react";
import PurchaseOrder from "./PurchaseOrder";
import { useParams } from "react-router-dom";

export default function Home({ match }) {
  // Set up state to store order data
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

   const { purchaseId } = useParams();

  useEffect(() => {
    // Define API endpoint using purchaseId
    const fetchOrderData = async () => {
      try {
        const token = localStorage.getItem("token")
        const response = await fetch(buildApiUrl(`/api/localpurchaseorder/${purchaseId}`), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Set your token here
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch order data');
        }

        const data = await response.json();
        setOrderData(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchOrderData();
  }, [purchaseId]); // Dependency array ensures it runs again if purchaseId changes

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return <PurchaseOrder orderData={orderData} />;
}
